import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Spin } from 'antd';

import Client from 'containers/app/client';
import { useUserWithRole } from 'hooks/custom-auth';

import './style.css';

const getCancelText = (status, role) => {
  if (status === 'expired') return 'Archive shift';
  if (role === 'isEmployer') return 'Cancel shift';
  if (role === 'isWorker') return 'Decline shift';
  return 'Cancel shift';
};

const BookingRequestActions = ({ id, request, status }) => {
  const [user, loading, error] = useUserWithRole(Client.auth);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  if (loading) return <Spin />;
  if (error) throw error;

  const { userId } = request;
  const { role } = user;

  const handleCancel = async () => {
    setLoadingDecline(true);
    await Client.rejectBookingRequest({ id, ...request });
    setLoadingDecline(false);
  };

  const handleAccept = async () => {
    setLoadingAccept(true);
    await Client.acceptBookingRequest({
      employerId: userId,
      bookingRequest: id,
    });
    setLoadingAccept(false);
  };

  const canCancel = status !== 'cancelled';
  const canAccept =
    role === 'isWorker' && status !== 'cancelled' && status !== 'expired';

  return (
    <section className="booking-detail-section -actions">
      {canCancel ? (
        <Button
          type="primary"
          danger
          onClick={handleCancel}
          loading={loadingDecline}
          disabled={loadingAccept || loadingDecline}
        >
          {getCancelText(status, role)}
        </Button>
      ) : null}

      {canAccept ? (
        <Button
          loading={loadingAccept}
          disabled={loadingAccept || loadingDecline}
          type="primary"
          onClick={handleAccept}
        >
          Accept shift
        </Button>
      ) : null}
    </section>
  );
};

BookingRequestActions.propTypes = {
  id: PropTypes.string.isRequired,
  request: PropTypes.shape({
    userId: PropTypes.string,
  }).isRequired,
  status: PropTypes.string.isRequired,
};

export default BookingRequestActions;
